angular.module('app').directive('fullAddress', function() {
    return {
        restrict: 'A',
        templateUrl: 'address.html',
        scope: {
            'item': '=fullAddress',
            'required': '=fullAddressRequired'
        }
    }
});
